/**
 * @ngdoc component
 * @name  common.product.product-view.component:itxProductViewDetails
 * @requires ItxScreenSizeSvc
 * @description
 * Product view details component. This component shows the information under the image in the category grid.
 * It's responsable for show the description, price and other things like, more colors leyend or made in, etc.
*/
(function () {

    'use strict';

    /**
     * View representation for a product
     * @name productViewDetailsCtrl
     * @type ItxProductViewDetailsCmpCtrl
     */
    var ItxProductViewDetailsCmp = {
        bindings: {
            product: '<',
            layout: '<',
            selectedColor: '<',
            inBundleDialog: '<',
            productIndex: '<',
            dialog:'<',
            onProductClick:'&',
            onProductChangeColor:'&',
            onExternalPercentage: '&'
        },
        controller: ItxProductViewDetailsCmpCtrl,
        templateUrl: 'ItxProductViewDetails.html'
    };

    angular.module('itxApp.common')
        .component('itxProductViewDetails', ItxProductViewDetailsCmp);

    ItxProductViewDetailsCmpCtrl.$inject = [
        'ItxTranslateSvc',
        'CmsConfigSvc'
    ];

    function ItxProductViewDetailsCmpCtrl( 
        ItxTranslateSvc,
        CmsConfigSvc
    ) {

        var _this = this;
        
        _this.$onInit = function () {
            _this.text={
                moreColors: '',
                new: ItxTranslateSvc.translateCms('legacy.ItxProductPage.nuevo')
            };

            _this.inditex = inditex;    
            _this.madeIn = null;
            _this.hasAttrMostrarPrecioTotal = null;
            _this.hasAttrMostrarRango = null;
            _this.daysView = false;
            _this.showCustomizationTag = false;

            _this.setMoreColors();
            
            /**
             * @property isCategoryNew
             * @description
             * True if I am in category Page and in a category new. Useful to show the 'new' label over products.
             * If I am in the category of new products it doesn't make any sense to put to all the products
             * the label "new".
             */
            if(inditex.iCategoryKey){
                _this.isCategoryNew = (inditex.iCategoryKey.indexOf('NUEVO') > -1);
            }
            
            _this.productDetailUrl = _this.product.getUrl();

            // Compara los dias de novedad para mostrar o no la etiqueta de "Nuevo"
            if(_this.product.availabilityDate){
                _this.diffDays =  moment().diff(_this.product.availabilityDate, 'days');

                if (_this.diffDays !== null && _this.diffDays !== undefined && _this.diffDays <= _this.product.state.configDays) {
                    _this.daysView = true;
                }
            } else {
                _this.daysView = false;
            }

            _.each(_this.product.attributes, function (attribute) {
                if (attribute.name == 'MADEIN_EXCLUSIVE') {
                    _this.onlineExclusive = attribute.value;
                } else if (attribute.name.indexOf('MADEIN_') !== -1) {
                    _this.madeIn = attribute.value;
                }
                if (attribute.name == 'mostrar_precio_total') {
                    _this.hasAttrMostrarPrecioTotal = true;
                }
                if (attribute.name == 'mostrar_rango') {
                    _this.hasAttrMostrarRango = true;
                }
            });

            if (_this.bundleProductSummaries) {
                _.each(_this.bundleProductSummaries, function (productBundleSummary) {
                    _.each(productBundleSummary.attributes, function (attribute) {
                        if (attribute.name == 'MADEIN_EXCLUSIVE') {
                            _this.onlineExclusive = attribute.value;
                        }
                    });
                });
            }

             //Tags

             if(_this.product.parent){
                _this.product.tags = _this.product.parent.tags;
             }
            
            _this.tag = _this.product && _this.product.tags &&
                _this.product.tags.length > 0 &&
                _.find(_this.product.tags[0].attachments, function (attachment) {
                    return attachment.name === 'LABEL_NEW';
            });    

            if(_this.product && _this.product.state && _this.product.state.xcustomization){
                CmsConfigSvc.getProperty('customizable_product_whitelist')
                .then(function (value) {
                    var confMocacosUR = _.keyBy(value); 
                    var mocaco = _this.product.getMocacocode();
                    if(mocaco){
                        var moca = mocaco.slice(0, -3);
                        var findMocaco = _.find(confMocacosUR, function (id) {
                                return moca === id;
                            });
                        
                        if(findMocaco){
                            _this.showCustomizationTag = true;
                        }
                    }
                });
            }
        };

        _this.setMoreColors = function () {
            _this.product && _this.product.activeDetail.colors.length > 3;
            let colors = _.filter(_this.product.activeDetail.colors, function(color){
                return color.visibility != 'hidden';
            });
            let num = colors.length - 4;
            if(num > 0){
                _this.showMoreColors = true;
                _this.text.moreColors = '+' + num;
            }
        };

        _this.goToProductDetail = function ($event, nameTrigger){
            $event.preventDefault();
            _this.onProductClick({product: _this.product});
        
            // Hotjar user behavior analytics
            if(nameTrigger && typeof hj != 'undefined'){
                hj('tagRecording', ['clickbundle']);   
            }
        };

        _this.changeColor = (color) => {
            _this.onProductChangeColor({color:color});
        };

        _this.showExternalPercentage = (percentage) => {

            if(_this.onExternalPercentage){
                _this.onExternalPercentage({percentage:percentage});
            }
        }

    }

})();
